import { MethodDescription } from '../method-description';

export const HashStudentIdMethodDescription = new MethodDescription();

HashStudentIdMethodDescription.name = 'hashStudentId';
HashStudentIdMethodDescription.fields = [
	'studentId',
];
HashStudentIdMethodDescription.usesToken = true;
